import { render, staticRenderFns } from "./page-out.vue?vue&type=template&id=72ad6284&scoped=true&"
import script from "./page-out.vue?vue&type=script&lang=js&"
export * from "./page-out.vue?vue&type=script&lang=js&"
import style0 from "./page-out.vue?vue&type=style&index=0&id=72ad6284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad6284",
  null
  
)

export default component.exports